import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import { LangLayout, RedirectToLang } from "@/i18n/routing";
import Home from "@/pages/Home";
import UrgentCare from "@/pages/UrgentCare";
import Nursing from "@/pages/Nursing";
import ServiceDetail from "@/pages/ServiceDetail";
import Locations from "@/pages/Locations";
import LocationDetail from "@/pages/LocationDetail";
import HowItWorks from "@/pages/HowItWorks";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import ServicePage from "@/pages/ServicePage";
import CareServicePage from "@/pages/CareServicePage";
import CommonHealthProblems from "@/pages/CommonHealthProblems";
import MedicalTourism from "@/pages/MedicalTourism";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path=":lang" element={<LangLayout />}>
          <Route index element={<Home />} />
          <Route path="urgent-care" element={<UrgentCare />} />
          <Route path="urgent-care/:slug" element={<ServiceDetail kind="urgent" />} />
          <Route path="nursing" element={<Nursing />} />
          <Route path="nursing/:slug" element={<ServiceDetail kind="nursing" />} />
          <Route path="locations" element={<Locations />} />
          <Route path="locations/:slug" element={<LocationDetail />} />
          <Route path="common-health-problems-vietnam" element={<CommonHealthProblems />} />
          <Route path="medical-tourism" element={<MedicalTourism />} />
          <Route path="how-it-works" element={<HowItWorks />} />
          <Route path="about" element={<About />} />
          <Route path="contact" element={<Contact />} />
          <Route path="privacy" element={<Privacy />} />
          <Route path="terms" element={<Terms />} />
          <Route path="doctor-to-hotel-vietnam" element={<ServicePage slug="/doctor-to-hotel-vietnam" />} />
          <Route path="online-doctor-consultation-vietnam" element={<ServicePage slug="/online-doctor-consultation-vietnam" />} />
          <Route path="clinic-hospital-booking-vietnam" element={<ServicePage slug="/clinic-hospital-booking-vietnam" />} />
          <Route path="urgent-medical-support-vietnam" element={<ServicePage slug="/urgent-medical-support-vietnam" />} />
          <Route path="nursing-care-vietnam" element={<CareServicePage slug="/nursing-care-vietnam" />} />
          <Route path="post-operative-nursing-vietnam" element={<CareServicePage slug="/post-operative-nursing-vietnam" />} />
          <Route path="elderly-care-support-vietnam" element={<CareServicePage slug="/elderly-care-support-vietnam" />} />
          <Route path="mother-baby-care-vietnam" element={<CareServicePage slug="/mother-baby-care-vietnam" />} />
          <Route path="*" element={<NotFound />} />
        </Route>
        <Route path="*" element={<RedirectToLang />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
